import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Dialog from '@cobliteam/ui/components/Dialog';
import Typography from '@cobliteam/ui/components/Typography';
import type { IconNames } from '@cobliteam/ui/icons';
import Icon from '@cobliteam/ui/icons';

interface FaceIdPhotoInstructionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContinue: () => void;
}

const instructions: { icon: IconNames; titleKey: string; descKey: string }[] = [
  { icon: 'sun', titleKey: 'photo_instructions.good_lighting', descKey: 'photo_instructions.good_lighting_desc' },
  { icon: 'user-round', titleKey: 'photo_instructions.no_accessories', descKey: 'photo_instructions.no_accessories_desc' },
  { icon: 'smile', titleKey: 'photo_instructions.face_front', descKey: 'photo_instructions.face_front_desc' },
];

const FaceIdPhotoInstructionsDialog = ({ open, onOpenChange, onContinue }: FaceIdPhotoInstructionsDialogProps) => {
  const { t } = useTranslation('drivers');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content size='sm'>
        <Dialog.Header>
          <Dialog.Title>{t('photo_instructions.title')}</Dialog.Title>
          <Dialog.Description className='sr-only'>{t('photo_instructions.subtitle')}</Dialog.Description>
          <Dialog.Close />
        </Dialog.Header>

        <Dialog.Body className='space-y-4'>
          <Typography variant='text-md' color='secondary'>
            {t('photo_instructions.subtitle')}
          </Typography>

          <div className='space-y-3'>
            {instructions.map(({ icon, titleKey, descKey }) => (
              <div key={titleKey} className='flex items-center gap-4 rounded-lg border border-gray-6 p-3'>
                <div className='flex size-10 shrink-0 items-center justify-center rounded-md bg-primary-2'>
                  <Icon name={icon} color='primary' size='md' />
                </div>
                <div>
                  <Typography variant='text-md-semibold'>{t(titleKey)}</Typography>
                  <Typography variant='text-md' color='secondary'>
                    {t(descKey)}
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </Dialog.Body>

        <Dialog.Footer className='flex justify-end gap-2'>
          <Dialog.Close asChild>
            <Button variant='ghost' color='primary'>
              {t('cancel')}
            </Button>
          </Dialog.Close>
          <Button variant='contained' color='primary' onClick={onContinue}>
            {t('photo_instructions.continue')}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};

export default FaceIdPhotoInstructionsDialog;
